import { defaultBreadcrumbs } from 'src/app/models/screen-prop'

const OtaChannelScreens = {
  OTA_CHANNEL: {
    PATH: '/ota-channel',
    TITLE: 'OTA Channel',
    TITLE_ALT: 'OTA Channel',
    PERMISSION: 'booking_report.read',
    breadcrumbs: defaultBreadcrumbs,
  },
  LIST_OTA_CHANNEL_MAPPING: {
    PATH: '/ota-channel/mappings',
    HEADER_NAME: 'OTA Channel Mapping',
    TITLE: 'OTA Mapping',
    TITLE_ALT: 'OTA Mapping',
    // PERMISSION: 'ota_channel_mapping.read',
    PERMISSION: 'booking_report.read',
    breadcrumbs: defaultBreadcrumbs,
  },
  LIST_OTA_CHANNEL_LOG: {
    PATH: '/ota-channel/logs',
    HEADER_NAME: 'OTA Channel Logs',
    TITLE: 'OTA Channel Log',
    TITLE_ALT: 'OTA Channel Log',
    // PERMISSION: 'ota_channel_log.read',
    PERMISSION: 'booking_report.read',
    breadcrumbs: defaultBreadcrumbs,
  },
  LIST_OTA_RESERVATION_QUEUE: {
    PATH: '/ota-channel/reservation-queue',
    HEADER_NAME: 'OTA Reservation Queue',
    TITLE: 'OTA Reservation Queue',
    TITLE_ALT: 'OTA Reservation Queue',
    PERMISSION: 'booking_report.read',
    breadcrumbs: defaultBreadcrumbs,
  },
}

export default OtaChannelScreens
